import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { Aside, EditButton, useDisclosure } from "sprint-common-web";

import { SystemPlatformDetailsContext } from "../../context/SystemPlatformDetailsContext";
import { EditShreqIdsForm } from "./EditShreqIdsForm";

export const EditShreqIdsButton = (): JSX.Element => {
    const { isOpen, onClose, onOpen } = useDisclosure();
    const { systemId } = useParams<{ systemId: string }>();

    const { isLoading } = useContext(SystemPlatformDetailsContext);

    return (
        <>
            <EditButton onClick={onOpen} isLabeled label="Edit" disabled={isLoading} testId="edit-shreq-ids" />
            <Aside isOpen={isOpen} type="form" headerText="Edit" onDismiss={onClose}>
                <EditShreqIdsForm onCancel={onClose} onSubmit={onClose} systemId={systemId} />
            </Aside>
        </>
    );
};
